/** Respuesta típica de @dataui/crud getMany (legacy paginado o array plano). */
export type CrudListResponse<T> = T | T[] | { data?: T[] } | null | undefined

/** Devuelve el primer ítem de una respuesta CRUD (login / búsqueda por userBaseId). */
export function unwrapCrudFirstItem<T>(res: CrudListResponse<T>): T | null {
  if (res == null) return null
  if (Array.isArray(res)) return res[0] ?? null
  if (typeof res === 'object' && 'data' in res) {
    const data = (res as { data?: T[] }).data
    return Array.isArray(data) ? (data[0] ?? null) : null
  }
  return res as T
}

/** Devuelve todos los ítems de una respuesta CRUD. */
export function unwrapCrudList<T>(res: CrudListResponse<T>): T[] {
  if (res == null) return []
  if (Array.isArray(res)) return res
  if (typeof res === 'object' && 'data' in res) {
    const data = (res as { data?: T[] }).data
    return Array.isArray(data) ? data : []
  }
  return [res as T]
}

/**
 * Detecta sesiones guardadas por error (objeto paginado en lugar de entidad).
 * Ocurre si auth_user almacenó `{ data: [...] }` sin desempaquetar.
 */
export function isCorruptedCrudSessionUser(user: unknown): boolean {
  if (!user || typeof user !== 'object') return false
  const record = user as Record<string, unknown>
  return Array.isArray(record['data']) && !('firstName' in record) && !('userBase' in record)
}

function looksLikeCatalogUuid(value: unknown): boolean {
  return typeof value === 'string' && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value)
}

export function isStaleDoctorProfileSessionUser(user: unknown): boolean {
  if (!user || typeof user !== 'object') return false
  const record = user as Record<string, unknown>
  const doctor = (record['doctor'] ?? record) as Record<string, unknown> | undefined
  if (!doctor || typeof doctor !== 'object' || !('isActiveMedical' in doctor)) return false

  const channels = Array.isArray(doctor['channels']) ? (doctor['channels'] as Record<string, unknown>[]) : []
  const specialties = Array.isArray(doctor['specialties']) ? (doctor['specialties'] as Record<string, unknown>[]) : []

  const hasBadChannel = channels.some((c) => c && !looksLikeCatalogUuid(c['channelId']))
  const hasBadSpecialty = specialties.some((s) => s && !looksLikeCatalogUuid(s['specialtyId']))

  return hasBadChannel || hasBadSpecialty
}
